module.exports = {"321171001":"丁卯街道","321171002":"大港街道","321171100":"姚桥镇","321171101":"大路镇","321171102":"丁岗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321171.json
// module id = 924
// module chunks = 0